export enum BoardLayoutType {
  FIT_TO_SCREEN = 'FIT_TO_SCREEN',
  FIT_TO_HEIGHT = 'FIT_TO_HEIGHT',
}
